import { isNullOrUndefined } from 'util';
import Vue from 'vue';

export function IsNull(val) {
    return val === null || val === undefined || val === 'undefined' || val === '';
}

export function IsNotNullOrEmpty(str) {
    return str == 'undefined' || str === undefined || str == null || str.trim() == '';
}

export function CreateUUID() {
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzabcdefghijklmnopqrstuvwxyz'.split('');
    const uuid = [];

    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';

    for (let i = 0; i < 36; i++) {
        if (!uuid[i]) {
            const r = 0 | (Math.random() * 16);
            uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
        }
    }

    return uuid.join('');
}

export function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

export function customerWindowDispatchEvent(ent, param) {
    var evt = document.createEvent('HTMLEvents');
    evt.param = param;
    evt.initEvent(ent, false, false);
    window.dispatchEvent(evt);
}
export function uuid(len, radix) {
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [],
        i;
    radix = radix || chars.length;

    if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
    } else {
        // rfc4122, version 4 form
        var r;

        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';

        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | (Math.random() * 16);
                uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
            }
        }
    }

    return uuid.join('');
}

export function ValueEquals(a, b) {
    if (a === b) return true;
    if (!(a instanceof Array) || !(b instanceof Array)) return false;
    if (a.length !== b.length) return false;
    for (let i = 0; i <= a.length; i++) {
        if (a[i] !== b[i]) return false;
    }
    return true;
}

/**
 * 判断数组里是否包含某元素
 * @return {boolean}
 */
export function IsArrayContains(array, obj) {
    for (let i = 0; i < array.length; i++) {
        if (array[i] === obj) return true;
    }
    return false;
}

/**
 * 判断是否为数组类型
 * @return {boolean}
 */
export function IsArray(obj) {
    if (obj && obj.length) return true;
    else return false;
}

/**
 * 时间格式化方法
 *
 * @static
 * @param {Date} date 日期对象
 * @param {string} fmt 格式化参数 hh:mm:ss
 * @memberof CommonMethod
 */
export function Format(date, fmt) {
    if (typeof date == 'string') {
        return date;
    }
    if (!date) date = new Date();
    var o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
        'H+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
    };
    var week = {
        '0': '/u65e5',
        '1': '/u4e00',
        '2': '/u4e8c',
        '3': '/u4e09',
        '4': '/u56db',
        '5': '/u4e94',
        '6': '/u516d',
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(
            RegExp.$1,
            (RegExp.$1.length > 1 ? (RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468') : '') +
                week[date.getDay() + '']
        );
    }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
            );
        }
    }
    return fmt;
}

export function IsString(str) {
    return typeof str == 'string' && str.constructor == String;
}

export function IsObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}

export function OpenBlankUrl(url) {
    var el = document.createElement('a');
    document.body.appendChild(el);
    el.href = url;
    el.target = '_blank';
    el.click();
    document.body.removeChild(el);
}

/// 获取当前时间的时间戳
export function getCurrentTimestamp() {
    return new Date().getTime();
}

/// 关闭当前窗口
export function closeWindow() {
    window.opener = null;
    window.open('', '_self');
    window.close();
}

/// 字符串转布尔
export function stringToBool(str) {
    if (typeof str !== 'string') {
        return false;
    }

    switch (str.toLowerCase()) {
        case 'true':
        case 'yes':
        case '1':
            return true;
        default:
            return false;
    }
}

// 是否是非空数组
export function IsNotEmptyArray(source) {
    return Array.isArray(source) && source.length > 0;
}

/**
 * HTML编码
 * @param {String} html
 */
export function htmlEncode(html) {
    //1.首先动态创建一个容器标签元素，如DIV
    var temp = document.createElement('div');
    //2.然后将要转换的字符串设置为这个元素的innerText(ie支持)或者textContent(火狐，google支持)
    temp.textContent != undefined ? (temp.textContent = html) : (temp.innerText = html);
    //3.最后返回这个元素的innerHTML，即得到经过HTML编码转换的字符串了
    var output = temp.innerHTML;
    temp = null;
    return output;
}

/**
 * HTML解码
 * @param {HTML} text
 */
export function htmlDecode(text) {
    //1.首先动态创建一个容器标签元素，如DIV
    var temp = document.createElement('div');
    //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
    temp.innerHTML = text;
    //3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
    var output = temp.innerText || temp.textContent;
    temp = null;
    return output;
}

/**
 * 校验表单名称、字段名称格式
 * @param str
 */
export function isValidateName(str, name = '') {
    var re1 = /^[0-9]/;
    //  /[-`~!@#$%^&*()+<>?:"{},.\/;'[\]]/;  // /[-`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/
    var reg2_unicode =
        '\u002d\u0060\u007e\u0021\u0040\u0023\u0024\u0025\u005e\u0026\u002a\u0028\u0029\u002b\u0026\u006c\u0074\u003b\u0026\u0067\u0074\u003b\u003f\u003a\u0026\u0071\u0075\u006f\u0074\u003b\u007b\u007d\u002c\u002e\u005c\u002f\u003b\u0026\u0023\u0033\u0039\u003b\u005b\u005c\u005d'; // /[-`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/
    //  /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/
    var re3_unicode =
        '\u0026\u0023\u0031\u0038\u0033\u003b\uff01\u0023\uffe5\uff08\u2014\u2014\uff09\uff1a\uff1b\u201c\u201d\u2018\u3001\uff0c\u007c\u300a\u3002\u300b\uff1f\u3001\u3010\u3011\u005b\u005c\u005d';
    var pwdblank = /\s/;

    var re2 = new RegExp('[' + htmlDecode(reg2_unicode) + ']');
    var re3 = new RegExp('[' + htmlDecode(re3_unicode) + ']');

    if (re1.test(str)) {
        return name + '不能以数字开头';
    }
    if (re2.test(str) || re3.test(str)) {
        return name + '不能包含特殊符号';
    }
    if (!isNullOrUndefined(str) && pwdblank.test(str)) {
        return name + '不能包含空格';
    }
    return '';
}

export function querystring2json(str) {
    let result = {};
    if (typeof str === 'string') {
        if (str.startsWith('?')) {
            str = str.substr(1);
        }
        if (str.indexOf('=') !== -1) {
            let arr = str.split('=');
            for (let i = 0; i < arr.length; i++) {
                result[arr[i]] = arr[++i];
            }
            return result;
        }
        return false;
    }
}

export function loadScript(path) {
    return loadFileByTag('script', path);
}

export function loadCss(path) {
    return loadFileByTag('link', path);
}

export function loadFileByTag(tag, path) {
    //load script
    return new Promise(resolve => {
        checkJSExist(path);
        //if (!checkJSExist(path)) {
        let script = document.createElement(tag);
        switch (tag) {
            case 'script':
                script.type = 'text/javascript';
                script.src = path;
                break;
            case 'link':
                script.type = 'text/css';
                script.href = path;
                script.rel = 'stylesheet';
                break;
        }

        if (script.readyState) {
            //IE
            script.onreadystatechange = () => {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    script.onreadystatechange = null;
                    resolve({
                        loaded: true,
                        status: 'Loaded',
                    });
                }
            };
        } else {
            //Others
            script.onload = () => {
                resolve({
                    loaded: true,
                    status: 'Loaded',
                });
            };
        }
        script.onerror = () =>
            resolve({
                loaded: false,
                status: 'Loaded',
            });
        document.getElementsByTagName('head')[0].appendChild(script);
        // } else {
        //     resolve({ loaded: true, status: 'Loaded' })
        // }
    });
}

export function checkJSExist(name) {
    var scriptEls = document.head.getElementsByTagName('script');
    for (let index = 0; index < scriptEls.length; index++) {
        if (scriptEls[index].src.indexOf(name) != -1) {
            scriptEls[index].parentNode.removeChild(scriptEls[index]);
            return true;
        }
    }
    return false;
}

export function parseReturnUrl(returnUrl) {
    if (IsNull(returnUrl)) return null;

    const index = returnUrl.indexOf('?');
    let path = index > -1 ? returnUrl.substr(0, index) : returnUrl;
    if (path === '' || path === '/') {
        return {
            paths: ['/'],
        };
    }
    if (path.indexOf('/') === 0) {
        path = path.substr(1, path.length);
    }
    const paths = path.split('/');
    return {
        paths: paths,
    };
}

export function isTrue(val) {
    if (typeof val === 'string') {
        return val === 'true';
    }
    return Boolean(val);
}

export function padLeftNumber(value, length) {
    if (!value) {
        return value;
    }
    var xsd = value.toString().split('.');
    if (xsd[0].length >= length) {
        return value;
    }

    while (xsd[0].length < length) {
        xsd[0] = '0' + xsd[0];
    }

    return xsd.join('.');
}

export function parseUrl(url) {
    const a = document.createElement('a');
    a.href = url;
    return {
        host: a.hostname,
        port: a.port,
        query: a.search,
        params: (function() {
            let ret = {};
            let seg = a.search.replace(/^\?/, '').split('&');
            let len = seg.length;
            for (let i = 0; i < len; ++i) {
                if (!seg[i]) continue;
                let s = seg[i].split('=');
                ret[s[0]] = s[1];
            }
            return ret;
        })(),
        hash: a.hash.replace('#', ''),
    };
}

export function IsValidDate(date) {
    return date instanceof Date && !isNaN(date.getTime());
}

export function typeOf(obj) {
    const toString = Object.prototype.toString;
    const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object',
    };
    return map[toString.call(obj)];
}
// deepCopy
export function deepCopy(data) {
    const t = typeOf(data);
    let o;

    if (t === 'array') {
        o = [];
    } else if (t === 'object') {
        o = {};
    } else {
        return data;
    }

    if (t === 'array') {
        for (let i = 0; i < data.length; i++) {
            o.push(deepCopy(data[i]));
        }
    } else if (t === 'object') {
        for (let i in data) {
            o[i] = deepCopy(data[i]);
        }
    }
    return o;
}

// 获取dom节点到顶部的距离
export function offsetTop(dom, t = 0) {
    if (dom.parentElement === document.body) {
        return t;
    } else {
        return offsetTop(dom.parentElement, dom.offsetTop + t); // 尾递归
    }
}
// 获取dom节点到左部的距
export function offsetLeft(dom, l = 0) {
    if (dom.parentElement === document.body) {
        return l;
    } else {
        return offsetLeft(dom.parentElement, dom.offsetLeft + l); // 尾递归
    }
}

export function debounce(callback, delay = 5000) {
    let timer = null;
    let self = this;
    return function() {
        if (timer) clearTimeout(timer);
        console.count();
        timer = setTimeout(() => {
            callback.apply(self, arguments);
        }, delay);
    };
}

// 校验名称输入是否合法
export function checkInputName(rule, value, callback) {
    const reg = /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/gi; // 仅允许输入 中文 a-z A-z 0-9
    if (IsNull(value)) {
        callback(new Error('内容不能为空'));
    } else if (IsNull(value.trim())) {
        callback(new Error('内容不能为空格'));
    } else if (reg.test(value)) {
        callback();
    } else {
        callback(new Error('不能包含特殊字符'));
    }
}
export function checkNumber(rule, value, callback) {
    const reg = /^([0]|[1-9][0-9]*)$/;
    if (IsNull(value)) {
        callback(new Error('内容不能为空'));
    } else if (reg.test(value)) {
        callback();
    } else {
        callback(new Error('只能输入正整数'));
    }
}

// export function checkPass(rule, value, callback) {
//     const reg = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[._~!@#$^&*])[A-Za-z0-9._~!@#$^&*]{8,20}$/;
//     if (IsNull(value)) {
//         callback(new Error('密码不能为空'));
//     } else if (reg.test(value)) {
//         callback();
//     } else {
//         callback(new Error('密码必须由字母、数字、特殊符号组成'));
//     }
// }

export function checkInputCode(rule, value, callback) {
    const reg = /^[a-zA-Z0-9]+$/gi; // 仅允许输入 a-z A-z 0-9
    if (IsNull(value)) {
        callback(new Error('内容不能为空'));
    } else if (IsNull(value.trim())) {
        callback(new Error('内容不能为空格'));
    } else if (reg.test(value)) {
        callback();
    } else {
        callback(new Error('不能包含特殊字符'));
    }
}

export function isIE() {
    return !!window.ActiveXObject || 'ActiveXObject' in window;
}

// 下载文件
export function DownloadFileByFileID(fileId) {
    if (IsNull(fileId)) return;
    const url = Vue.prototype.$apiURL + '/api/Form/DownloadFile/' + fileId;
    const aLink = document.createElement('a');
    aLink.href = url;
    aLink.target = '_blank';
    document.body.appendChild(aLink);
    aLink.click();
    document.body.removeChild(aLink);
}

// 预览图片
export function PreviewImageByFileID(fileId) {
    if (IsNull(fileId)) return;
    const url = Vue.prototype.$apiURL + '/api/Form/PreviewImage/' + fileId;
    const aLink = document.createElement('a');
    aLink.href = url;
    aLink.target = '_blank';
    document.body.appendChild(aLink);
    aLink.click();
    document.body.removeChild(aLink);
}

// 判断当前浏览器是否是移动端浏览器
export function IsMobile() {
    console.log('userAgent: ', navigator.userAgent);
    return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
}

//判断一个字符串是否包含另一个(不区分大小写)
export function IsTextContains(source,str) {
    if(source&&str){
        return source.trim().toLowerCase().indexOf(str.trim().toLowerCase()) !== -1;
    }else return false;
}
